import { createFileRoute } from "@tanstack/react-router";

import { BaseEditCreateModal } from "@/components/_Modals/BaseEditCreateModal";
import { DriversForm } from "@/features/dashboard/motoristas/components/DriversForm";

export const Route = createFileRoute("/_private/dashboard/_base/motoristas/cadastrar/modal")({
  component: () => (
    <BaseEditCreateModal title="Criar novo Motorista" from="/dashboard/motoristas/cadastrar">
      <DriversForm />
    </BaseEditCreateModal>
  )
});
